export default __webpack_public_path__ + "static/media/character-referral.a8eac5fa.svg";